import { css } from '@emotion/react';
import { GumtreeTheme } from '@gumtree/ui-library/src/base/themes/gumtree-theme';
import { breakpoints, mediaQuery } from '../media';

export const getSegmentedButtonsContainerCss = (_theme: GumtreeTheme) => css`
    width: 100%;
    display: flex;
`;

export const getSegmentedButtonCss = (theme: GumtreeTheme, isSelected: boolean) => css`
    && {
        display: flex;
        justify-content: center;
        align-items: center;

        background-color: ${theme.palette.action.secondary.unselected.default};
        color: ${theme.palette.action.secondary.unselected.mainContrastText};

        ${isSelected === true &&
        `
            background-color: ${theme.palette.action.secondary.selected.default};
            color: ${theme.palette.action.secondary.selected.mainContrastText};
    
    `}

        border-top: solid thin ${theme.palette.action.secondary.selected.default};
        border-bottom: solid thin ${theme.palette.action.secondary.selected.default};
        border-left: solid thin ${theme.palette.action.secondary.selected.default};
        border-right: none;

        :first-of-type {
            border-top-left-radius: ${theme.spacing.s};
            border-bottom-left-radius: ${theme.spacing.s};
        }

        :last-child {
            border-right: solid thin ${theme.palette.action.secondary.selected.default};
            border-top-right-radius: ${theme.spacing.s};
            border-bottom-right-radius: ${theme.spacing.s};
        }

        padding: ${theme.spacing.s};

        flex: 1;

        :hover {
            cursor: pointer;
        }
    }
`;

export const getIconWrapperCss = (theme: GumtreeTheme) => css`
    padding-right: ${theme.spacing.s};

    ${mediaQuery.until(breakpoints.small)} {
        display: none;
    }
`;
